// extracted by mini-css-extract-plugin
export default {"content":"MonthlyProgressSection_content__38EUL"};